import { IoCContainer, WebCoreIoCKeys } from '../../..';
import { SidebarComponent } from '../sidebar-component.class';

export class MouseEventHandler {
    private clickListener?: (e: MouseEvent) => void;

    private buffer: number = 20;
    private peek: number = 8;

    private get settings(): any {
        return IoCContainer.get(WebCoreIoCKeys.IWebCoreSettings);
    }

    constructor(private sidebarComponents: SidebarComponent[]) {}

    public init(): void {
        this.sidebarComponents.forEach(sidebar => this.applyClosedState(sidebar));

        if (this.clickListener) {
            return;
        }

        this.clickListener = (e: MouseEvent) => {
            this.sidebarComponents.forEach(sidebar => {
                if (!sidebar.controlBar || sidebar.isPanelOpen || sidebar.dragHandler.isDragging || sidebar.resizeHandler.isResizing) {
                    return;
                }

                switch (sidebar.currentSide) {
                    case 'left':
                        if (e.clientX < this.buffer) {
                            this.openSidebar(sidebar);
                        }
                        break;

                    case 'right':
                        if (window.innerWidth - e.clientX < this.buffer) {
                            this.openSidebar(sidebar);
                        }
                        break;

                    case 'top':
                        if (e.clientY < this.buffer) {
                            this.openSidebar(sidebar);
                        }
                        break;

                    case 'bottom':
                        if (window.innerHeight - e.clientY < this.buffer) {
                            this.openSidebar(sidebar);
                        }
                        break;
                }
            });
        };

        document.addEventListener('click', this.clickListener);
    }

    public openSidebar(sidebar: SidebarComponent): void {
        if (!sidebar.controlBar) {
            return;
        }

        sidebar.isPanelOpen = true;

        switch (sidebar.currentSide) {
            case 'left':
                sidebar.controlBar.style.transition = `left 0.3s ease`;
                sidebar.controlBar.style.width = `${sidebar.panelWidth}px`;
                sidebar.controlBar.style.height = `${sidebar.panelHeight}px`;
                sidebar.controlBar.style.left = '0';
                break;

            case 'right':
                sidebar.controlBar.style.transition = `right 0.3s ease`;
                sidebar.controlBar.style.width = `${sidebar.panelWidth}px`;
                sidebar.controlBar.style.height = `${sidebar.panelHeight}px`;
                sidebar.controlBar.style.right = '0';
                break;

            case 'top':
                sidebar.controlBar.style.transition = `top 0.3s ease`;
                sidebar.controlBar.style.width = `${sidebar.panelWidth}px`;
                sidebar.controlBar.style.height = `${sidebar.panelHeight}px`;
                sidebar.controlBar.style.top = '0';
                break;

            case 'bottom':
                sidebar.controlBar.style.transition = `bottom 0.3s ease`;
                sidebar.controlBar.style.width = `${sidebar.panelWidth}px`;
                sidebar.controlBar.style.height = `${sidebar.panelHeight}px`;
                sidebar.controlBar.style.bottom = '0';
                break;
        }
    }

    public closeSidebar(sidebar: SidebarComponent): void {
        if (!sidebar.controlBar) {
            return;
        }

        sidebar.isPanelOpen = false;

        switch (sidebar.currentSide) {
            case 'left':
                sidebar.controlBar.style.transition = 'left 0.3s ease';
                sidebar.controlBar.style.left = `-${sidebar.panelWidth - this.peek}px`;
                break;

            case 'right':
                sidebar.controlBar.style.transition = 'right 0.3s ease';
                sidebar.controlBar.style.right = `-${sidebar.panelWidth - this.peek}px`;
                break;

            case 'top':
                sidebar.controlBar.style.transition = 'top 0.3s ease';
                sidebar.controlBar.style.top = `-${sidebar.panelHeight - this.peek}px`;
                break;

            case 'bottom':
                sidebar.controlBar.style.transition = 'bottom 0.3s ease';
                sidebar.controlBar.style.bottom = `-${sidebar.panelHeight - this.peek}px`;
                break;
        }
    }

    public resetSidebar(sidebar: SidebarComponent): void {
        sidebar.isPanelOpen = false;
        this.applyClosedState(sidebar);
    }

    private applyClosedState(sidebar: SidebarComponent): void {
        if (!sidebar.controlBar || sidebar.isPanelOpen) {
            return;
        }

        sidebar.controlBar.style.transition = 'none';
        sidebar.controlBar.style.width = `${sidebar.panelWidth}px`;
        sidebar.controlBar.style.height = `${sidebar.panelHeight}px`;

        switch (sidebar.currentSide) {
            case 'left':
                sidebar.controlBar.style.top = '0';
                sidebar.controlBar.style.bottom = '0';
                sidebar.controlBar.style.right = 'auto';
                sidebar.controlBar.style.left = `-${sidebar.panelWidth - this.peek}px`;
                break;

            case 'right':
                sidebar.controlBar.style.top = '0';
                sidebar.controlBar.style.bottom = '0';
                sidebar.controlBar.style.left = 'auto';
                sidebar.controlBar.style.right = `-${sidebar.panelWidth - this.peek}px`;
                break;

            case 'top':
                sidebar.controlBar.style.left = '0';
                sidebar.controlBar.style.right = '0';
                sidebar.controlBar.style.bottom = 'auto';
                sidebar.controlBar.style.top = `-${sidebar.panelHeight - this.peek}px`;
                break;

            case 'bottom':
                sidebar.controlBar.style.left = '0';
                sidebar.controlBar.style.right = '0';
                sidebar.controlBar.style.top = 'auto';
                sidebar.controlBar.style.bottom = `-${sidebar.panelHeight - this.peek}px`;
                break;
        }
    }

    public destroy(): void {
        if (this.clickListener) {
            document.removeEventListener('click', this.clickListener);
            this.clickListener = undefined;
        }
    }
}
